import { createContext, useCallback, useRef, useState } from "react";
const ToastContext = createContext();

export function ToastContextProvider({ children }) {
  const [toastList, setToastList] = useState([]);
  // Poruke se skidaju po IDENTIFIKATORU, ne po mestu u nizu. Po mestu je bilo
  // netačno: dok tajmer čeka, ispred njega uđe ili izađe druga poruka i indeks
  // pokazuje na pogrešnu.
  const lastId = useRef(0);

  const removeToast = useCallback((id) => {
    setToastList((prev) => prev.filter((toast) => toast.id !== id));
  }, []);

  const emptyToastList = useCallback(() => setToastList([]), []);

  const insertIntoToastList = useCallback(
    (text, status, unique, selfDestructible, executable, executableFunction) => {
      const id = ++lastId.current;
      setToastList((prev) => {
        // Poruke sa `unique` se ne gomilaju dok ista stoji na ekranu. Provera
        // ide UNUTAR menjača — spolja je gledala listu uhvaćenu u zatvorenju,
        // pa su dvojnici prolazili kad dva poziva stignu u istom prolazu.
        if (unique && prev.some((toast) => toast.unique === unique)) return prev;
        return [
          ...prev,
          { id, text, status, unique, selfDestructible, executable, executableFunction },
        ];
      });
    },
    [],
  );

  // Svi menjači rade kroz funkcionalni oblik i nemaju zavisnosti, pa im se
  // identitet ne menja između iscrtavanja. To nije uredništvo: `Toast` na
  // `removeToast` vezuje svoj tajmer, a pozivaoci `insertIntoToastList` u
  // `useEffect`-ima — da se menjaju, tajmer bi se poništavao pri svakoj tuđoj
  // poruci, a effect-i vrteli u krug.
  const valueToShare = {
    toastList,
    emptyToastList,
    removeToast,
    insertIntoToastList,
  };

  return (
    <ToastContext.Provider value={valueToShare}>
      {children}
    </ToastContext.Provider>
  );
}

export default ToastContext;
